import React, { useState, useEffect, useRef } from 'react';
import Sidebar from './components/Sidebar';
import TopBar from './components/TopBar';
import SystemHealthBanner from './components/SystemHealthBanner';
import ApprovalsWaitingBanner from './components/ApprovalsWaitingBanner';
import { PortStatusBar } from './components/PortStatusBadge';
import HouseholdWaitingBanner from './components/HouseholdWaitingBanner';
import AppSwitchSwipe from './components/AppSwitchSwipe';
import Dashboard from './pages/Dashboard';
import OrderDetails from './pages/OrderDetails';
import OrderDesk from './pages/OrderDesk';
import OrderUpdates from './pages/OrderUpdates';
import ShippingRules from './pages/ShippingRules';
import ShippingToday from './pages/ShippingToday';
import PackingCosts from './pages/PackingCosts';
import ProfitPerBox from './pages/ProfitPerBox';
import DailyPpb from './pages/DailyPpb';
import PpbSegments from './pages/PpbSegments';
import SalesReport from './pages/SalesReport';
import SalesReportAP from './pages/SalesReportAP';
import HardCrabCosts from './pages/HardCrabCosts';
import FacebookLeads from './pages/FacebookLeads';
import InventoryLimitAlerts from './pages/InventoryLimitAlerts';
import ProfitAnalysis from './pages/ProfitAnalysis';
import HardCrabCalendarAP from './pages/HardCrabCalendarAP';
import DailySummary from './pages/DailySummary';
import MetaCampaigns from './pages/MetaCampaigns';
import MarketingBrain from './pages/MarketingBrain';
import MetaInvoices from './pages/MetaInvoices';
import EmailCampaigns from './pages/EmailCampaigns';
import CustomerPhotos from './pages/CustomerPhotos';
import ConversionSettings from './pages/ConversionSettings';
import Conversions from './pages/Conversions';
import GoogleCampaigns from './pages/GoogleCampaigns';
// Fulfillment
import RemainingToday from './pages/RemainingToday';
import Products from './pages/Products';
import ProductAlerts from './pages/ProductAlerts';
import GiftCertificates from './pages/GiftCertificates';
import FulfillmentOps from './pages/FulfillmentOps';
// Orders
import PlacedToday from './pages/PlacedToday';
import OnHold from './pages/OnHold';
import PendingCharge from './pages/PendingCharge';
import OpenClaims from './pages/OpenClaims';
import FraudAlert from './pages/FraudAlert';
import AkHiOrders from './pages/AkHiOrders';
import AddressValidations from './pages/AddressValidations';
import LargeGround from './pages/LargeGround';
import LargeGroundAP from './pages/LargeGroundAP';
import InventoryLimit from './pages/InventoryLimit';
import FraudCheck from './pages/FraudCheck';
import SetVipOverlay from './pages/SetVipOverlay';
import SetVipPeriod from './pages/SetVipPeriod';
import EmailConfig from './pages/EmailConfig';
import CrabSuppliers from './pages/CrabSuppliers';
import ProductAlertConfig from './pages/ProductAlertConfig';
import UnmappedIgnore from './pages/UnmappedIgnore';
import SpecialCharges from './pages/SpecialCharges';
import AddressOverrides from './pages/AddressOverrides';
import AddressExceptions from './pages/AddressExceptions';
import UpsBlocklist from './pages/UpsBlocklist';
import ShippingHolidays from './pages/ShippingHolidays';
import AccessPointReport from './pages/AccessPointReport';
// Reports
import ClaimOrders from './pages/ClaimOrders';
import ShippingInsurance from './pages/ShippingInsurance';
import ProfitReport from './pages/ProfitReport';
import ProfitReportAP from './pages/ProfitReportAP';
import HardCrabCalendar from './pages/HardCrabCalendar';
import ShippingReport from './pages/ShippingReport';
import OrderMethod from './pages/OrderMethod';
import NewVsReturning from './pages/NewVsReturning';
import NewVsReturningAP from './pages/NewVsReturningAP';
import ReferringAd from './pages/ReferringAd';
import ReferringAdAP from './pages/ReferringAdAP';
import StateBreakdown from './pages/StateBreakdown';
import UnfinishedOrders from './pages/UnfinishedOrders';
import UnfinishedOrdersAP from './pages/UnfinishedOrdersAP';
import OrderDataExport from './pages/OrderDataExport';
import RefundsReships from './pages/RefundsReships';
import ProductReport from './pages/ProductReport';
import CategorySalesReport from './pages/CategorySalesReport';
import VipCashReport from './pages/VipCashReport';
import ShippingMargin from './pages/ShippingMargin';
// Profit Margin
import ProfitMargin from './pages/ProfitMargin';
import ProfitMarginByProduct from './pages/ProfitMarginByProduct';
import ProfitMarginDetail from './pages/ProfitMarginDetail';
// Customers
import CustomerSearch from './pages/CustomerSearch';
import CustomerAnalysis from './pages/CustomerAnalysis';
import VipSearch from './pages/VipSearch';
import VipClub from './pages/VipClub';
import VipHealth from './pages/VipHealth';
import VipOptOuts from './pages/VipOptOuts';
import CustomerCategorization from './pages/CustomerCategorization';
import LinkedAccounts from './pages/LinkedAccounts';
// UPS
import Reconciliation from './pages/Reconciliation';
import DeliveryReconciliation from './pages/DeliveryReconciliation';
import UpsBills from './pages/UpsBills';
import PendingActivity from './pages/PendingActivity';
import UpsContractPricing from './pages/UpsContractPricing';
import ContractEvaluation from './pages/ContractEvaluation';
import UpsClaims from './pages/UpsClaims';
// HCD
import YieldReport from './pages/YieldReport';
import YieldSheet from './pages/YieldSheet';
import VendorSummary from './pages/VendorSummary';
import HardCrabPlanning from "./pages/HardCrabPlanning";
// Inventory
import Inventory from './pages/Inventory';
import Pricing from './pages/Pricing';
import CostMapping from './pages/CostMapping';
import BCProductSetup from './pages/BCProductSetup';
import PriceHistory from './pages/PriceHistory';
import PriceComparison from './pages/PriceComparison';
import CompetitorPricing from './pages/CompetitorPricing';
import WasteLog from './pages/WasteLog';
import CrabCakePlanner from './pages/CrabCakePlanner';
import CrMonthlyReport from './pages/CrMonthlyReport';
import CncBusGroups from './pages/CncBusGroups';
import SiteContent from './pages/BigCommerce/SiteContent';
import PdpLiveViewers from './pages/PdpLiveViewers';
// RingCentral
import RingCentral from './pages/RingCentral';
import UnifiedInbox from './pages/UnifiedInbox';
import ScreenPop from './components/ScreenPop';
import ClaudeBuild from './components/ClaudeBuild';
// Payroll
import Payroll from './pages/Payroll';
// Time Clock (TCP Plus integration)
import TimeClock from './pages/TimeClock';
// Checkout Telemetry (BC checkout error/event log viewer — Cosmos via webapp01)
import CheckoutTelemetry from './pages/CheckoutTelemetry';
import CheckoutFunnel from './pages/CheckoutFunnel';
import TrafficAnalysis from './pages/TrafficAnalysis';
import BannerScheduler from './pages/BannerScheduler';
// To-Do
import TodoBoard from './pages/TodoBoard';
import Cameras from './pages/Cameras';
// Personal
import TodoGreg from './pages/TodoGreg';
import Household from './pages/Household';
import TeamBoard from './pages/TeamBoard';
import MyBoard from './pages/MyBoard';
import DayPlanner from './pages/DayPlanner';
import Delegation from './pages/Delegation';
// Marketing
import MarketingStudio from './pages/MarketingStudio';
import ContentBuilder from './pages/ContentBuilder';
import VideoStudio from './pages/VideoStudio';
import CncEventCopy from './pages/CncEventCopy';
import MediaLibrary from './pages/MediaLibrary';
import MediaLibraryDedupe from './pages/MediaLibraryDedupe';
import MediaIntake from './pages/MediaIntake';
import MetaBuilder from './pages/MetaBuilder';
import YouTubeUploader from './pages/YouTubeUploader';
import GiphySync from './pages/GiphySync';
import CallCenterOutreach from './pages/CallCenterOutreach';
import Seo from './pages/Seo';
// Configure
import ConfigureSite from './pages/ConfigureSite';
import UserManagement from './pages/UserManagement';
import RolePermissions from './pages/RolePermissions';
import TroubleTickets from './pages/TroubleTickets';
import PortStatus from './pages/PortStatus';
import KnowledgeCapture from './pages/KnowledgeCapture';
import JimmyKnowledge from './pages/JimmyKnowledge';
import KnowledgeBase from './pages/KnowledgeBase';
import Ask from './pages/Ask';
import AskPageView from './pages/AskPageView';
import Tasks from './pages/Tasks';
// BigCommerce
import BcCustomFields from './pages/BigCommerce/CustomFields';
import RecipesAdmin from './pages/BigCommerce/RecipesAdmin';
// Feedback
import Feedback from './pages/Feedback';
import FeedbackByCategory from './pages/FeedbackByCategory';
import FeedbackFollowUp from './pages/FeedbackFollowUp';
import FeedbackResolution from './pages/FeedbackResolution';
import FeedbackAlerts from './pages/FeedbackAlerts';
import ProductFeedback from './pages/ProductFeedback';
import Reviews from './pages/Reviews';
import GoogleReplies from './pages/GoogleReplies';
import AuditLog from './pages/AuditLog';
import SecurityAlertsConfig from './pages/SecurityAlertsConfig';
import OrderAlertsSettings from './pages/OrderAlertsSettings';
import OrderAlertList from './pages/OrderAlertList';
import SeventhStreetBrain from './pages/SeventhStreetBrain';
import AccountingBrain from './pages/AccountingBrain';
import QuickBooks from './pages/QuickBooks';
import ProcurementBrain from './pages/ProcurementBrain';
import ContactCenterBrain from './pages/ContactCenterBrain';
import ImprovementsBrain from './pages/ImprovementsBrain';
import ContactBoard from './pages/ContactBoard';
import DelayTracker from './pages/DelayTracker';
import PromoCodes from './pages/PromoCodes';
import Approvals from './pages/Approvals';
import InvoiceApprovals from './pages/InvoiceApprovals';
import Vendors from './pages/Vendors';
import CashOutlook from './pages/CashOutlook';
import PayrollRecords from './pages/PayrollRecords';
import PayrollPlanner from './pages/PayrollPlanner';
import Attendance from './pages/Attendance';
import Budget from './pages/Budget';
import QbdScans from './pages/QbdScans';
import AuthnetDeposits from './pages/AuthnetDeposits';
import CoachSettings from './pages/CoachSettings';
import Chargebacks from './pages/Chargebacks';
import CncFraud from './pages/CncFraud';
import Login from './pages/Login';
import { isLoggedIn, logout, getCurrentUser, validateSession } from './services/auth';
import { neonQuery } from './services/api';
import { plantRepMarker } from './services/repMarker';
import './App.css';

export default function App() {
  const [loggedIn, setLoggedIn] = useState(isLoggedIn());
  const [currentPage, setCurrentPage] = useState(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('qbo')) return 'quickbooks';
    return urlParams.get('page') || sessionStorage.getItem('cpx_page') || 'dashboard';
  });
  const [selectedOrderId, setSelectedOrderId] = useState(() => {
    // ?order=<id> lets a new-tab deep link (e.g. from Daily Summary) load a
    // specific order; falls back to the last-viewed order for in-app nav.
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('order') || sessionStorage.getItem('cpx_orderId') || null;
  });
  const [navParams, setNavParams] = useState(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const ticket = urlParams.get('ticket');
    if (ticket) return { ticketId: parseInt(ticket) };
    const task = urlParams.get('task');
    if (task) return { taskId: parseInt(task) };
    // ?invoice=<id> - the deep link carried by an approval notification email, so
    // the approver lands on the bill they were asked about instead of the CPx
    // homepage. It survives the login screen because these initialisers run on
    // mount whether or not there is a session: by the time Login hands back the
    // page and the invoice id are already set, and Login only strips ?setup and
    // ?reset from the URL.
    const invoice = urlParams.get('invoice');
    if (invoice && /^\d+$/.test(invoice)) return { apDocumentId: parseInt(invoice, 10) };
    return null;
  });
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [pageKey, setPageKey] = useState(0);
  const [previousPage, setPreviousPage] = useState(null);
  const [screenPopEnabled, setScreenPopEnabled] = useState(() => localStorage.getItem('screenPopEnabled') !== 'false');
  const screenPopUserDirtyRef = useRef(false);

  const handleScreenPopToggle = (val) => {
    screenPopUserDirtyRef.current = true;
    setScreenPopEnabled(val);
  };

  // Load user preferences from Neon on login (syncs across devices/PWA)
  useEffect(() => {
    if (!loggedIn) return;
    const user = getCurrentUser();
    if (!user?.id) return;
    (async () => {
      try {
        const rows = await neonQuery('user_pref_get', { user_id: user.id });
        const prefs = rows?.[0] || {};
        if (prefs.screenPopEnabled !== undefined && !screenPopUserDirtyRef.current) {
          const val = prefs.screenPopEnabled !== 'false';
          setScreenPopEnabled(val);
          localStorage.setItem('screenPopEnabled', String(val));
        }
      } catch (e) { /* preferences load failed, use localStorage default */ }
    })();
  }, [loggedIn]);

  useEffect(() => {
    if (window.location.hostname === 'localhost') document.title = 'LOCAL CPx Admin';
  }, []);

  // Event-day jump: on a Crab & Cruise event day the first open of the day goes
  // straight to CNCx Event Mode, so the phone doesn't have to be opened, swiped
  // and logged into just to watch check-ins. Runs before the auth gate on
  // purpose — the point is to skip signing into CPx at all (you still sign into
  // CNCx).
  //
  // ⚠️ v1 (2026-08-15) gated on `display-mode: standalone` and never fired on
  // Greg's phone on event day. The code shipped and ran — the SW never caches
  // this origin — so a guard returned early, and standalone is the only one that
  // could: an "add to home screen" shortcut, a wrapper, or a launcher that
  // reports minimal-ui/browser all read as false. Device detection is now
  // "phone-shaped OR standalone", which still can't catch a desktop (a coarse
  // pointer AND a short edge <= 820px), and the reason for every decision is
  // observable via ?jumpdebug=1 — a silent redirect that silently doesn't
  // happen is undebuggable, which is exactly how this got missed.
  //
  // Also re-checks when the app is brought back to the foreground: iOS resumes
  // a backgrounded PWA without remounting, so a mount-only check can never fire
  // for an app that was already open.
  //
  // Guards: phone/PWA only (desktop CPx is the all-day workspace and bouncing it
  // would be hostile); once per day, flagged BEFORE navigating — which is also
  // what stops a loop with the CNCx->CPx swipe; and ?nojump=1 to opt out.
  useEffect(() => {
    let stopped = false;

    const decide = async () => {
      const qs = new URLSearchParams(window.location.search);
      const debug = qs.has('jumpdebug');
      const report = (verdict, detail) => {
        if (debug) window.alert(`Event-day jump\n\n${verdict}\n\n${JSON.stringify(detail || {}, null, 1)}`);
      };
      try {
        if (qs.has('nojump')) return report('Skipped — ?nojump is set');

        const standalone = (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches)
          || window.navigator.standalone === true;
        const coarse = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
        const shortEdge = Math.min(
          (window.screen && window.screen.width) || 99999,
          (window.screen && window.screen.height) || 99999
        );
        const phone = coarse && shortEdge <= 820;
        if (!standalone && !phone) {
          return report('Skipped — not a phone or installed app', { standalone, coarse, shortEdge });
        }

        // ?jumptest=1 — dry-run the whole path on a non-event day (proves the
        // redirect + CNCx deep link work from this device). Ignores both the
        // event-day requirement and the once-per-day flag, and doesn't consume
        // the day's jump.
        const force = qs.has('jumptest');

        const todayKey = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York' }).format(new Date());
        if (!force && localStorage.getItem('cpxEventDayJump') === todayKey) {
          return report('Skipped — already jumped today', { todayKey });
        }

        let info = null;
        if (!force) {
          // Cache the day's answer so a non-event day costs one request per day,
          // not one per app open.
          const cached = localStorage.getItem('cpxEventDayCheck');
          if (cached) {
            const o = JSON.parse(cached);
            if (o && o.date === todayKey) info = o;
          }
          if (!info) {
            const res = await fetch('/.netlify/functions/cnc-event-day');
            info = await res.json();
            if (info && info.date === todayKey) {
              localStorage.setItem('cpxEventDayCheck', JSON.stringify(info));
            }
          }
          if (!info || !info.eventDay) return report('Skipped — no event today', info || {});
        }
        if (stopped) return undefined;

        if (!force) localStorage.setItem('cpxEventDayJump', todayKey);
        report(force ? 'TEST — jumping to CNCx Event Mode' : 'Jumping to CNCx Event Mode', { event: info ? info.name : 'test' });
        // replace(), not assign() — the back gesture shouldn't ping-pong.
        window.location.replace('https://cncx-prototype.netlify.app/?page=event-mode');
        return undefined;
      } catch (e) {
        // Never block CPx on this check.
        return report('Error — check skipped', { error: e.message });
      }
    };

    decide();
    const onVisible = () => { if (document.visibilityState === 'visible') decide(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => { stopped = true; document.removeEventListener('visibilitychange', onVisible); };
  }, []);

  // Phase 3: enforce the server-side session window in the UI. validateSession()
  // calls auth_validate_session on the function; if the row is gone (6-day expiry,
  // explicit logout elsewhere, deleted user) we bounce to the login page so the user
  // is not stranded with a stale localStorage token.
  useEffect(() => {
    if (!loggedIn) return;
    let cancelled = false;
    const check = async () => {
      try {
        const valid = await validateSession();
        if (!valid && !cancelled) {
          await logout();
          window.location.reload();
        }
      } catch (e) {
        console.warn('[session-check] failed:', e.message);
      }
    };
    check();
    const interval = setInterval(check, 30 * 60 * 1000);
    return () => { cancelled = true; clearInterval(interval); };
  }, [loggedIn]);

  // Auto-sync to Neon every 15 minutes while an Admin is logged in (production only)
  useEffect(() => {
    if (!loggedIn) return;
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') return;
    const user = getCurrentUser();
    if (!user?.roles?.includes('Admin')) return;

    const runSync = async () => {
      try {
        // Use the background variant so the 26s Netlify HTTP gateway timeout
        // doesn't kill the function mid-flight. The auto-sync now includes a
        // tracking + scale-cost backfill that pushes runtime past 26s for any
        // bill-import-heavy day. Background fns return 202 immediately and
        // run up to 15 minutes; we don't need the response.
        await fetch('/api/sync-background', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ days: 1 }),
        });
      } catch (e) {
        console.warn('[auto-sync] failed:', e.message);
      }
    };

    // Run once shortly after login, then every 15 minutes
    const initial = setTimeout(runSync, 30_000);
    const interval = setInterval(runSync, 15 * 60_000);
    return () => { clearTimeout(initial); clearInterval(interval); };
  }, [loggedIn]);

  // Customer Relations reps: leave their name with crabplace.com so the orders they
  // place for customers are recorded as taken by them (services/repMarker.js).
  useEffect(() => {
    if (loggedIn) plantRepMarker();
  }, [loggedIn]);

  const handleLogin = (user) => {
    setLoggedIn(true);
    setSidebarOpen(false);
  };
  const handleLogout = async () => {
    if (!window.confirm('Are you sure you want to log out?')) return;
    await logout();
    setLoggedIn(false);
  };

  const navigateTo = (page, orderId = null, params = null) => {
    if (page === currentPage) setPageKey(k => k + 1);
    setPreviousPage(currentPage);
    setCurrentPage(page);
    sessionStorage.setItem('cpx_page', page);
    if (orderId) {
      setSelectedOrderId(orderId);
      sessionStorage.setItem('cpx_orderId', orderId);
    }
    setNavParams(params);
    setSidebarOpen(false);
    // A deep link (?page=daily-summary&tab=winback, ?order=, ?ticket=...) only means
    // "open here"; leaving it in the address bar made a refresh jump back to it
    // instead of reloading the page you moved to (Greg, Oct 20, 2026).
    const qs = new URLSearchParams(window.location.search);
    const deepLink = ['page', 'tab', 'order', 'ticket', 'task', 'invoice', 'qbo', 'bcProductId'];
    if (deepLink.some(k => qs.has(k))) {
      deepLink.forEach(k => qs.delete(k));
      const rest = qs.toString();
      window.history.replaceState(null, '', window.location.pathname + (rest ? `?${rest}` : '') + window.location.hash);
    }
  };

if (!loggedIn) {
  return (
    <>
      <Login onLogin={handleLogin} />
      <AppSwitchSwipe targetUrl="https://cncx-prototype.netlify.app" targetName="Crab & Cruise" />
    </>
  );
}

  const renderPage = () => {
    // Greg's personal to-do pages. The menu hides them, but a link or a remembered page could
    // still land somebody else here, so anyone else gets their own board instead.
    const GREG_ONLY_PAGES = ['todo-greg', 'todo-plan', 'todo-delegation', 'todo-board'];
    if (GREG_ONLY_PAGES.includes(currentPage) && getCurrentUser()?.staffName !== 'Greg Cain') {
      return <MyBoard key={pageKey} navigateTo={navigateTo} />;
    }
    switch (currentPage) {
      case 'dashboard': return <Dashboard key={pageKey} navigateTo={navigateTo} />;
      case 'order-details': return <OrderDetails key={pageKey} orderId={selectedOrderId} navigateTo={navigateTo} fromPage={previousPage} />;
      // Order Desk (beta): the new order screen CS is trying on real orders (Oct 29, 2026).
      case 'order-desk': return <OrderDesk key={pageKey} orderId={selectedOrderId} navigateTo={navigateTo} />;
      // Fulfillment
      case 'shipping-today': return <ShippingToday key={pageKey} navigateTo={navigateTo} initialDate={navParams?.date} />;
      case 'packing-costs': return <PackingCosts key={pageKey} />;
      case 'profit-per-box': return <ProfitPerBox key={pageKey} navigateTo={navigateTo} />;
      case 'daily-ppb': return <DailyPpb key={pageKey} navigateTo={navigateTo} />;
      case 'ppb-segments': return <PpbSegments key={pageKey} navigateTo={navigateTo} />;
      case 'remaining-today': return <RemainingToday key={pageKey} navigateTo={navigateTo} />;
      case 'products': return <Products key={pageKey} />;
      case 'product-alerts': return <ProductAlerts key={pageKey} navigateTo={navigateTo} />;
      case 'gift-certificates': return <GiftCertificates key={pageKey} />;
      case 'ops-planner': return <FulfillmentOps key={pageKey} />;
      // Orders
      case 'placed-today': return <PlacedToday key={pageKey} navigateTo={navigateTo} />;
      case 'on-hold': return <OnHold key={pageKey} navigateTo={navigateTo} />;
      case 'pending-charge': return <PendingCharge key={pageKey} navigateTo={navigateTo} />;
      case 'open-claims': return <OpenClaims key={pageKey} navigateTo={navigateTo} />;
      case 'fraud-alert': return <FraudAlert key={pageKey} navigateTo={navigateTo} />;
      case 'chargebacks': return <Chargebacks key={pageKey} navigateTo={navigateTo} />;
      case 'cnc-fraud': return <CncFraud key={pageKey} />;
      case 'ak-hi': return <AkHiOrders key={pageKey} navigateTo={navigateTo} />;
      case 'address-validations': return <AddressValidations key={pageKey} navigateTo={navigateTo} />;
      case 'large-ground': return <LargeGround key={pageKey} navigateTo={navigateTo} />;
      case 'shipping-holidays': return <ShippingHolidays key={pageKey} />;
      case 'ups-blocklist': return <UpsBlocklist key={pageKey} />;
      case 'address-exceptions': return <AddressExceptions key={pageKey} />;
      case 'address-overrides': return <AddressOverrides key={pageKey} />;
      case 'special-charges': return <SpecialCharges key={pageKey} />;
      case 'unmapped-ignore': return <UnmappedIgnore key={pageKey} />;
      case 'product-alert-config': return <ProductAlertConfig key={pageKey} />;
      case 'crab-suppliers': return <CrabSuppliers key={pageKey} />;
      case 'email-config': return <EmailConfig key={pageKey} />;
      case 'set-vip-period': return <SetVipPeriod key={pageKey} />;
      case 'set-vip-overlay': return <SetVipOverlay key={pageKey} />;
      case 'fraud-check': return <FraudCheck key={pageKey} />;
      case 'inventory-limit': return <InventoryLimit key={pageKey} />;
      case 'large-ground-ap': return <LargeGroundAP key={pageKey} navigateTo={navigateTo} />;
      case 'access-point-report': return <AccessPointReport key={pageKey} navigateTo={navigateTo} />;
      case 'physical-gc': return <GiftCertificates key={pageKey} />;
      case 'order-updates': return <OrderUpdates key={pageKey} navigateTo={navigateTo} />;
      case 'shipping-rules': return <ShippingRules key={pageKey} />;
      // Reports
      case 'claim-orders': return <ClaimOrders key={pageKey} navigateTo={navigateTo} />;
      case 'shipping-insurance': return <ShippingInsurance key={pageKey} />;
      case 'profit-report': return <ProfitReport key={pageKey} />;
      case 'profit-report-ap': return <ProfitReportAP key={pageKey} />;
      case 'sales-report': return <SalesReport key={pageKey} navigateTo={navigateTo} />;
      case 'hard-crab-calendar-ap': return <HardCrabCalendarAP key={pageKey} />;
      case 'profit-analysis': return <ProfitAnalysis key={pageKey} />;
      case 'inventory-limit-alerts': return <InventoryLimitAlerts key={pageKey} />;
      case 'facebook-leads': return <FacebookLeads key={pageKey} />;
      case 'hard-crab-costs': return <HardCrabCosts key={pageKey} navigateTo={navigateTo} />;
      case 'sales-report-ap': return <SalesReportAP key={pageKey} />;
      case 'seventh-street-brain': return <SeventhStreetBrain key={pageKey} />;
      case 'accounting-brain': return <AccountingBrain key={pageKey} />;
      case 'quickbooks': return <QuickBooks key={pageKey} />;
      case 'procurement-brain': return <ProcurementBrain key={pageKey} />;
      case 'contact-center-brain': return <ContactCenterBrain key={pageKey} />;
      case 'improvements': return <ImprovementsBrain key={pageKey} />;
      case 'contact-board': return <ContactBoard key={pageKey} />;
      case 'delay-tracker': return <DelayTracker key={pageKey} navigateTo={navigateTo} />;
      case 'promo-codes': return <PromoCodes key={pageKey} />;
      case 'approvals': return <Approvals key={pageKey} initialDocumentId={navParams?.apDocumentId} />;
      case 'all-approvals': return <Approvals key={pageKey} kind="all" initialDocumentId={navParams?.apDocumentId} />;
      case 'invoice-approvals': return <InvoiceApprovals key={pageKey} initialDocumentId={navParams?.apDocumentId} />;
      case 'vendors': return <Vendors key={pageKey} />;
      case 'cash-outlook': return <CashOutlook key={pageKey} />;
      case 'payroll-records': return <PayrollRecords key={pageKey} />;
      case 'payroll-planner': return <PayrollPlanner key={pageKey} />;
      case 'attendance': return <Attendance key={pageKey} />;
      case 'budget': return <Budget key={pageKey} />;
      case 'qbd-scans': return <QbdScans key={pageKey} />;
      case 'authnet-deposits': return <AuthnetDeposits key={pageKey} />;
      case 'coach-settings': return <CoachSettings key={pageKey} />;
      case 'daily-summary': return <DailySummary key={pageKey} navigateTo={navigateTo} />;
      case 'hard-crab-calendar': return <HardCrabCalendar key={pageKey} />;
      case 'shipping-report': return <ShippingReport key={pageKey} navigateTo={navigateTo} />;
      case 'order-method': return <OrderMethod key={pageKey} />;
      case 'new-vs-returning': return <NewVsReturning key={pageKey} />;
      case 'new-vs-returning-ap': return <NewVsReturningAP key={pageKey} />;
      case 'referring-ad': return <ReferringAd key={pageKey} />;
      case 'referring-ad-ap': return <ReferringAdAP key={pageKey} />;
      case 'state-breakdown': return <StateBreakdown key={pageKey} />;
      case 'unfinished-orders': return <UnfinishedOrders key={pageKey} navigateTo={navigateTo} />;
      case 'unfinished-orders-ap': return <UnfinishedOrdersAP key={pageKey} />;
      case 'order-data-export': return <OrderDataExport key={pageKey} />;
      case 'refunds-reships': return <RefundsReships key={pageKey} navigateTo={navigateTo} />;
      case 'product-report': return <ProductReport key={pageKey} />;
      case 'category-sales': return <CategorySalesReport key={pageKey} />;
      case 'vip-cash-report': return <VipCashReport key={pageKey} />;
      case 'shipping-margin': return <ShippingMargin key={pageKey} navigateTo={navigateTo} />;
      // Profit Margin
      case 'profit-margin-orders':
      case 'profit-margin': return <ProfitMargin key={pageKey} navigateTo={navigateTo} />;
      case 'profit-margin-by-product': return <ProfitMarginByProduct key={pageKey} />;
      case 'profit-margin-detail': return <ProfitMarginDetail key={pageKey} navigateTo={navigateTo} />;
      // Customers
      case 'customer-search': return <CustomerSearch key={pageKey} navigateTo={navigateTo} initialQuery={navParams} />;
      case 'customer-analysis': return <CustomerAnalysis key={pageKey} navigateTo={navigateTo} />;
      case 'vip-search': return <VipSearch key={pageKey} navigateTo={navigateTo} />;
      case 'vip-club': return <VipClub key={pageKey} navigateTo={navigateTo} />;
      case 'vip-health': return <VipHealth key={pageKey} />;
      case 'vip-optouts': return <VipOptOuts key={pageKey} />;
      case 'customer-categorization': return <CustomerCategorization key={pageKey} navigateTo={navigateTo} />;
      case 'linked-accounts': return <LinkedAccounts key={pageKey} initialQuery={navParams} />;
      // UPS
      case 'reconciliation-shipping':
      case 'reconciliation': return <Reconciliation key={pageKey} />;
      case 'reconciliation-bills': return <UpsBills key={pageKey} navigateTo={navigateTo} />;
      case 'pending-activity': return <PendingActivity key={pageKey} navigateTo={navigateTo} />;
      case 'ups-contract': return <UpsContractPricing key={pageKey} />;
      case 'ups-contract-eval': return <ContractEvaluation key={pageKey} />;
      case 'reconciliation-delivery': return <DeliveryReconciliation key={pageKey} navigateTo={navigateTo} />;
      case 'ups-claims': return <UpsClaims key={pageKey} navParams={navParams} navigateTo={navigateTo} />;
      // Feedback
      case 'feedback-summary':
      case 'feedback': return <Feedback key={pageKey} navigateTo={navigateTo} />;
      case 'feedback-by-category': return <FeedbackByCategory key={pageKey} navigateTo={navigateTo} />;
      case 'feedback-follow-up': return <FeedbackFollowUp key={pageKey} navigateTo={navigateTo} />;
      case 'feedback-cs-resolution': return <FeedbackResolution key={pageKey} navigateTo={navigateTo} />;
      case 'feedback-low-score-alerts': return <FeedbackAlerts key={pageKey} navigateTo={navigateTo} />;
      case 'feedback-by-product': return <ProductFeedback key={pageKey} navigateTo={navigateTo} />;
      case 'reviews': return <Reviews key={pageKey} navigateTo={navigateTo} />;
      case 'google-review-replies': return <GoogleReplies key={pageKey} />;
      case 'audit-log': return <AuditLog key={pageKey} />;
      case 'security-alerts': return <SecurityAlertsConfig key={pageKey} />;
      case 'order-alerts': return <OrderAlertsSettings key={pageKey} />;
      case 'alerts': return <OrderAlertList key={pageKey} navigateTo={navigateTo} />;
      case 'yield-report': return <YieldReport key={pageKey} />;
      case 'yield-sheet': return <YieldSheet key={pageKey} />;
      case 'vendor-summary': return <VendorSummary key={pageKey} />;
      case 'demand-planning': return <HardCrabPlanning key={pageKey} />;
      case 'hard-crab-planning': return <HardCrabPlanning key={pageKey} />;
      case 'inventory': return <Inventory key={pageKey} navigateTo={navigateTo} />;
      case 'pricing': return <Pricing key={pageKey} />;
      case 'cost-mapping': return <CostMapping key={pageKey} />;
      case 'bc-product-setup': return <BCProductSetup key={pageKey} />;
      case 'price-history': return <PriceHistory key={pageKey} />;
      case 'price-comparison': return <PriceComparison key={pageKey} />;
      case 'competitor-pricing': return <CompetitorPricing key={pageKey} />;
      case 'waste-log': return <WasteLog key={pageKey} />;
      case 'crab-cake-planner': return <CrabCakePlanner key={pageKey} />;
      case 'cr-monthly-report': return <CrMonthlyReport key={pageKey} />;
      case 'cnc-bus-groups': return <CncBusGroups key={pageKey} />;
      case 'site-content': return <SiteContent key={pageKey} />;
      case 'ringcentral': return <RingCentral key={pageKey} navigateTo={navigateTo} screenPopEnabled={screenPopEnabled} onScreenPopToggle={handleScreenPopToggle} />;
      case 'unified-inbox': return <UnifiedInbox key={pageKey} navigateTo={navigateTo} />;
      case 'payroll': return <Payroll key={pageKey} navigateTo={navigateTo} />;
      case 'time-clock': return <TimeClock key={pageKey} navigateTo={navigateTo} />;
      case 'checkout-telemetry': return <CheckoutTelemetry key={pageKey} />;
      case 'pdp-live-viewers': return <PdpLiveViewers key={pageKey} />;
      case 'checkout-funnel': return <CheckoutFunnel key={pageKey} />;
      case 'traffic-analysis': return <TrafficAnalysis key={pageKey} />;
      case 'banner-scheduler': return <BannerScheduler key={pageKey} />;
      // BigCommerce
      case 'bc-custom-fields': return <BcCustomFields key={pageKey} />;
      case 'bc-recipes': return <RecipesAdmin key={pageKey} />;
      case 'marketing-brain': return <MarketingBrain key={pageKey} navigateTo={navigateTo} />;
      case 'meta-campaigns': return <MetaCampaigns key={pageKey} navigateTo={navigateTo} />;
      case 'meta-invoices': return <MetaInvoices key={pageKey} />;
      case 'google-campaigns': return <GoogleCampaigns key={pageKey} />;
      case 'email-campaigns': return <EmailCampaigns key={pageKey} />;
      case 'customer-photos': return <CustomerPhotos key={pageKey} navigateTo={navigateTo} />;
      case 'conversion-settings': return <ConversionSettings key={pageKey} />;
      case 'conversions': return <Conversions key={pageKey} />;
      case 'todo-board': return <TodoBoard key={pageKey} />;
      case 'cameras': return <Cameras key={pageKey} navigateTo={navigateTo} />;
      case 'todo-greg': return <TodoGreg key={pageKey} navigateTo={navigateTo} />;
      case 'household': return <Household key={pageKey} />;
      case 'team-board': return <TeamBoard key={pageKey} />;
      case 'my-board': return <MyBoard key={pageKey} navigateTo={navigateTo} />;
      case 'wish-list': return <TeamBoard key={pageKey} initialTab="wish" />;
      case 'todo-plan': return <DayPlanner key={pageKey} navigateTo={navigateTo} />;
      case 'todo-delegation': return <Delegation key={pageKey} />;
      case 'marketing-studio': return <MarketingStudio key={pageKey} />;
      case 'content-builder': return <ContentBuilder key={pageKey} />;
      case 'video-studio': return <VideoStudio key={pageKey} />;
      case 'cnc-event-copy': return <CncEventCopy key={pageKey} />;
      // old Landing Pages builder retired 2026-08-13; kept as a redirect so any
      // saved link or sessionStorage page id lands somewhere sensible.
      case 'landing-pages': return <ContentBuilder key={pageKey} />;
      case 'media-library': return <MediaLibrary key={pageKey} />;
      case 'media-intake': return <MediaIntake key={pageKey} />;
      case 'media-library-dedupe': return <MediaLibraryDedupe key={pageKey} />;
      case 'meta-builder': return <MetaBuilder key={pageKey} navigateTo={navigateTo} />;
      case 'youtube-upload': return <YouTubeUploader key={pageKey} />;
      case 'giphy-sync': return <GiphySync key={pageKey} />;
      case 'call-center': return <CallCenterOutreach key={pageKey} navigateTo={navigateTo} />;
      case 'seo': return <Seo key={pageKey} />;
      case 'configure-site': return <ConfigureSite key={pageKey} />;
      case 'configure-users': return <UserManagement key={pageKey} />;
      case 'configure-roles': return <RolePermissions key={pageKey} />;
      case 'port-status': return <PortStatus key={pageKey} navigateTo={navigateTo} />;
      case 'trouble-tickets': return <TroubleTickets key={pageKey} initialTicketId={navParams?.ticketId} />;
      case 'jimmy-knowledge': return <JimmyKnowledge key={pageKey} />;
      case 'knowledge-capture': return <KnowledgeCapture key={pageKey} />;
      case 'knowledge-base': return <KnowledgeBase key={pageKey} />;
      case 'ask': return <Ask key={pageKey} />;
      case 'ask-page': return <AskPageView key={pageKey} />;
      case 'tasks': return <Tasks key={pageKey} initialTaskId={navParams?.taskId} />;
      default: return <Dashboard key={pageKey} navigateTo={navigateTo} />;
    }
  };

  return (
    // cpx-touch: on a phone, force every field to 16px so iOS Safari stops
    // zooming the page in on focus (and never zooming back out). Applied at the
    // shell so the nav search and the topbar order/customer search are covered
    // too - they are the first things you touch on the way to any page.
    <div className="app cpx-touch">
      {sidebarOpen && <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />}
      <Sidebar currentPage={currentPage} navigateTo={navigateTo} onLogout={handleLogout} isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} collapsed={sidebarCollapsed} onToggleCollapse={() => setSidebarCollapsed(c => !c)} />
      <div className="main-content">
        <TopBar navigateTo={navigateTo} onMenuToggle={() => setSidebarOpen(o => !o)} />
        {/* ⚠️ ABOVE SYSTEM HEALTH ON PURPOSE. This is the one banner in the app
            that is somebody's actual work rather than a note about the plumbing,
            and a crabber does not get paid until it is acted on. */}
        <ApprovalsWaitingBanner onOpen={() => navigateTo('all-approvals')} />
        <HouseholdWaitingBanner onOpen={() => navigateTo('household')} />
        <SystemHealthBanner />
        <div className="page-content">
          <PortStatusBar page={currentPage} navigateTo={navigateTo} />
          {renderPage()}
        </div>
      </div>
      <ScreenPop navigateTo={navigateTo} enabled={screenPopEnabled} />
      {/* Mounted only inside the signed-in layout, unlike AppSwitchSwipe: it asks the
          server whether this account is enabled for it, and there is no account to ask
          about on the login screen. It renders nothing at all for anyone without a row
          in cpx_build_access. */}
      <ClaudeBuild currentPage={currentPage} />
      <AppSwitchSwipe targetUrl="https://cncx-prototype.netlify.app" targetName="Crab & Cruise" />
    </div>
  );
}
